<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="600px">
      <data-loader :is_on="is_saving"  :is_saving="is_saving"/>

      <v-card class="universal-vcard knowledge-vcard">
        <div class="universal-vdialog-title">
          <span>{{ $t('components.knowledge_management.dialog.' + (isEditMode ? 'edit' : 'add')) }} {{ $t('components.knowledge_management.dialog.knowledge') }}</span>
        </div>
        <div class="template-select-text-wrapper knowledge-select-wrapper">
          <v-select
            v-model="formData.categoryId"
            class="template-select-drop"
            :items="categories"
            item-text="name"
            item-value="id"
            :label="$t('components.knowledge_management.dialog.select_category')"
            required
          ></v-select>
        </div>
        <v-text-field
          class="universal-vdialog-textfield"
          v-model="formData.title"
          :label="$t('components.knowledge_management.dialog.title')"
          required
        ></v-text-field>
        <div class="container">
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t('components.knowledge_management.dialog.detailed_description') }}</span>
            </label>
            <textarea class="form-textarea" v-model="formData.description" />
          </div>
        </div>
        <div class="template-select-text-wrapper knowledge-select-wrapper">
        <v-combobox
        class="template-select-drop knowledge-drop"
          v-model="formData.tags"
          :items="availableTags"
          :label="$t('components.knowledge_management.dialog.select_or_enter_tag')"
          chips
          multiple
          deletable-chips
          append-icon="mdi-chevron-down"
          :menu-props="{ bottom: true, offsetY: true }"
        ></v-combobox>
        </div>
        <div class="container knowledge-container">
          <form-files-upload 
            :deleted_items.sync="files.deleted"
            :existing_items.sync="files.previous"
            :new_items.sync="files.new"
            :is_single_upload="false"
            :can_download="true"
            @getFile="getAttachment"
         />
        </div>
        
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
        <div class="universal-vdialog-button vbutton-secondary" text @click="close">{{ $t('components.knowledge_management.dialog.cancel') }}</div>
        <div class="universal-vdialog-button vbutton-primary" text @click="is_saving ? '' : saveKnowledge()" >{{ is_saving ? $t('components.knowledge_management.dialog.saving') : $t('components.knowledge_management.dialog.save') }}  </div>
    </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import graph from '@/services/graph'

import {
  createKnowledge,
  updateKnowledge,
  getKnowledge,
} from "../../apiCallers/promise_handler_db/knowledgeManagement";
import projCaller from "@/apiCallers/promise_handler_db/projects"

import formFilesUpload from '../formElements/formFilesUpload.vue';
import DataLoader from '../generalComponents/DataLoader.vue';

export default {
  components: { formFilesUpload, DataLoader },
  name: "KnowledgeDialog",
  props: {
    categories: Array,
    availableTags: Array,
  },
  data() {
    return {
      files:{
      deleted : [],
      previous : [],
      new : []
      },

      is_saving : false,
      dialog: false,
      formData: {
        id: null,
        categoryId: "",
        title: "",
        description: "",
        tags: [],
        files: [],
      },
      removedFiles: [],
      isEditMode: false,
    };
  },
  methods: {
    async getAttachment(attach_id,file_name){
        this.accessToken = this.$store.state.aToken 
        await projCaller.getTaskAttachment(this.group_url, attach_id).then((resp)=>{
          //pripremanje download linka
          var link = document.createElement("a");
          link.setAttribute("href", resp.data.webUrl);
          link.setAttribute("target", "_blank");
          link.setAttribute("download", file_name);
          link.click();
        })
      },
    handleInput(newTag) {
      // If the tag typed does not exist in availableTags, add it
      console.log(newTag);
      if (newTag && !this.availableTags.includes(newTag)) {
        this.availableTags.push(newTag);
      }
    },
    handleChange(newTags) {
      // Clean up availableTags to remove any tags not in use
      this.availableTags = this.availableTags.filter(
        (tag) => newTags.includes(tag) || this.formData.tags.includes(tag)
      );
    },
    customFilter(item, queryText, itemText) {
      // Custom filter to allow adding tags not already in the list
      const hasValue = (val) => (val != null ? val : "");
      const text = hasValue(itemText).toLowerCase();
      const query = hasValue(queryText).toLowerCase();
      return text.indexOf(query) > -1;
    },
    async open(knowledge = null, sel_category = "") {
      if (knowledge) {
        this.formData = { ...knowledge, files: [] };
        console.log(knowledge)
        this.files.previous = await graph.getMultipleFiles(knowledge.links);
        console.log(this.files)
        this.isEditMode = true;


      } else {
        this.resetFormData();
        this.formData.categoryId = sel_category;
        this.isEditMode = false;
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    saveKnowledge() {
      this.is_saving = true;
      const method = this.isEditMode ? updateKnowledge : createKnowledge;
      const params = this.isEditMode
        ? [
            this.formData.id,
            this.formData.categoryId,
            this.formData.title,
            this.formData.tags,
            this.formData.description,
            this.files.deleted,
            this.files.previous,
            this.files.new,
          ]
        : [
            this.formData.categoryId,
            this.formData.title,
            this.formData.tags,
            this.formData.description,
            this.files.new,
          ];

      method(...params)
        .then(() => {
          this.is_saving = false;
          this.$emit("update-list");
          this.close();
        })
        .catch((error) => {
          console.error("Failed to save knowledge entry:", error);

          this.is_saving = false;
        });
    },
    handleFilesUpload(event) {
      this.formData.files = Array.from(event.target.files);
    },
    resetFormData() {
      this.formData = {
        categoryId: "",
        title: "",
        description: "",
        tags: [],
        files: [],
      };
    },
  },
};
</script>
